import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from '../../shared/DeleteButton.js';
import { formatDate } from '../../../utils/dateFormat.js';
import './RainCardList.css';

const RainCard = ({ row, onDeleted }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const date = row.date ? formatDate(row.date.substring(0, 10)) : '—';

  return (
    <div className={`rain-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="rain-card-main">
        <div className="rain-card-amount">{row.amount}mm</div>
        <div className="rain-card-area">{row.area || '—'}</div>
        <div className="rain-card-chevron">{expanded ? '▲' : '▼'}</div>
        <div className="rain-card-date">{date}</div>
      </div>

      {expanded && (
        <div className="rain-card-detail" onClick={e => e.stopPropagation()}>
          <div className="rain-card-detail-row">
            <span>{t('amount')}</span><span>{row.amount}mm</span>
          </div>
          <div className="rain-card-detail-row">
            <span>{t('date')}</span><span>{date}</span>
          </div>
          <div className="rain-card-detail-row">
            <span>{t('area')}</span><span>{row.area || '—'}</span>
          </div>
          <div className="rain-card-detail-row">
            <span>{t('who')}</span><span>{row.created_by || '—'}</span>
          </div>
          <div className="rain-card-detail-row">
            <span>{t('from')}</span><span>{row.phone || '—'}</span>
          </div>
          <div className="rain-card-actions">
            <DeleteButton
              collection="rain"
              data={[row]}
              onComplete={onDeleted}
              onError={() => {}}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const RainCardList = ({ data, onRefresh }) => {
  return (
    <div className="rain-card-list">
      {data && data.map(row => (
        <RainCard key={row._id} row={row} onDeleted={onRefresh} />
      ))}
      {(!data || data.length === 0) && (
        <div className="rain-card-empty">—</div>
      )}
    </div>
  );
};

export default RainCardList;
